export default __webpack_public_path__ + "static/media/VegshelfTwitter-600x314.feaf58f1.png";